<div class="SLV2-populr-book-card-box">
    <div class="SLV2-populr-book-cvr-wrap">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/{{popularBookCardData?.cover}}" />
    </div>
    <div class="SLV2-populr-book-content">
        <h3 class="SLV2-populr-book-title">{{popularBookCardData?.title}}</h3>
    </div>
</div>